/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum TermsStatus {
  accepted = 'accepted',
  accept_required = 'accept_required'
}
